import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
const WindowHeight = window.innerHeight;

const useStyles = makeStyles({
  root: {
    borderRadius: 20,
    height: 532,
    width: "100%",
  },
  media: {
    height: 470,
  },
  content: {
    height: 38,
  },
});

export default function MediaCard1(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          component="img"
          alt="Contemplative Reptile"
          image={props.imgURL}
          title="Contemplative Reptile"
        />
        <CardContent className={classes.content}>
          <Typography style={{ fontWeight: "bold", fontSize: "20px" }}>
            {props.title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
